import axios from 'axios'

export const tickets = {
  namespaced: true,
  state: {
    ticketTypes: [],
    selected: [],
    currency: '',
    taxes: 0,
    total: 0,
    allTickets: false
  },

  mutations: {
    setCurrency(state, currency) {
      state.currency = currency || ''
    },
    setList(state, list) {
      state.ticketTypes = _removeDuplicates(state.ticketTypes.concat(list.ticket_types)).slice().sort(function(a, b) {
        return a.position - b.position
      })
    },
    setAllTickets(state, status) {
      state.allTickets = status
    },
    clean(state) {
      state.ticketTypes = []
    },
    addTicket(state, { ticket, quantity }) {
      state.ticketTypes.forEach(item => {
        if (item.id === ticket.id) item.quantity = quantity
      })
      if (quantity > 0) {
        if (!state.selected.find(item => item.id === ticket.id)) {
          var ticketAux = ticket
          ticketAux.quantity = quantity
          ticketAux.tickets = []
          for (let i = 0; i < quantity; i++) {
            ticketAux.tickets.push({
              ticket_type: ticket.id
            })
          }
          state.selected.push(ticketAux)
        } else {
          state.selected.forEach((item, index) => {
            if (item.id === ticket.id) {
              item.quantity = quantity
              item.tickets = []
              for (let i = 0; i < quantity; i++) {
                item.tickets.push({
                  ticket_type: ticket.id
                })
              }
            }
          })
        }
      } else {
        state.selected = state.selected.filter(item => {
          return item.id !== ticket.id
        })
      }
    },
    selectTicket(state, data) {
      state.selected = data
    },
    cleanSelected(state, data) {
      state.selected = []
      state.currency = ''
      state.taxes = 0
      state.total = 0
    },
    fillTicket(state, { ticket, name, id_card, index }) {
      state.selected.forEach(item => {
        if (item.id === ticket.id) {
          item.tickets[ index ].name = name || item.tickets[ index ].name
          item.tickets[ index ].id_card = id_card || item.tickets[ index ].id_card
        }
      })
    },
    removeTicket(state, { ticket, quantity }) {
      state.ticketTypes.forEach(item => {
        if (item.id === ticket.id) item.quantity = quantity
      })
    },
    setTaxesAndTotal(state) {
      state.taxes = 0
      state.total = 0
      state.selected.map(item => {
        state.taxes = state.taxes + item.quantity * item.customer_commission
        state.total = state.total + item.price * item.quantity
      })
      state.total = state.total + state.taxes
    }
  },

  actions: {
    async filter({ commit }, payload) {
      await axios
        .get('/ticket-types/', {
          params: payload
        })
        .then(res => {
          commit('setList', res.data)
          if (res.data.next_page === null) commit('setAllTickets', true)
        })
        .catch(res => {
          if (res.status !== 401) {
            if (typeof window !== 'undefined') {
              if (typeof CustomEvent === 'function') {
                var event = new CustomEvent('showError', {
                  detail: {
                    textI18N: 'error.title',
                    error: res
                  }
                })
                window.dispatchEvent(event)
              }
            }
          }
        })
    },
    clean({ commit }, payload) {
      commit('clean')
    },
    add({ commit }, payload) {
      commit('addTicket', payload)
    },
    select({ commit }, payload) {
      commit('selectTicket', payload)
    },
    cleanSelected({ commit }, payload) {
      commit('cleanSelected', payload)
    },
    fill({ commit }, payload) {
      commit('fillTicket', payload)
    },
    remove({ commit }, payload) {
      commit('removeTicket', payload)
    },
    setTaxesAndTotal({ commit }) {
      commit('setTaxesAndTotal')
    },
    setCurrency({ commit }, payload) {
      commit('setCurrency', payload)
    }
  }
}
function _removeDuplicates(ticket_types) {
  const unique = ticket_types
    .map(e => e.id)
    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)
    // eliminate the dead keys & store unique objects
    .filter(e => ticket_types[ e ]).map(e => ticket_types[ e ])
  return unique
}
